import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStudentEntitlementsApi } from "@/api/reportingApi";

export const getStudentEntitlementsThunk = createAsyncThunk(
    "reporting/studentEntitlements",
    async (parentId: number, { rejectWithValue }) => {
        try {
            const response = await getStudentEntitlementsApi(parentId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
